import { render, staticRenderFns } from "./ResetPassword2.vue?vue&type=template&id=056a2f24&scoped=true&"
import script from "./ResetPassword2.vue?vue&type=script&lang=js&"
export * from "./ResetPassword2.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword2.vue?vue&type=style&index=0&id=056a2f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056a2f24",
  null
  
)

export default component.exports